import { faker } from '@faker-js/faker';
import _ from 'lodash';
import { genericId, orderId, tenantId } from '@cnx-saas/utils-cnx-id';
import {
  MatchOrder,
  Order,
  OrderArticle,
  OrderImport,
  OrderInput,
  OrderStatus,
  OrderType,
} from '../types';
import { fakeLocationFactory } from './location';
import { fakeArticleFactory } from './article';
import { fakeLoadFactory } from './load';

export const fakeOrderFactory = {
  createOrderImport: (data?: Partial<OrderImport>): OrderImport => {
    return {
      externalReference: genericId(),
      type: _.sample(Object.values(OrderType)) ?? OrderType.DELIVERY,
      locationExternalReference: genericId(),
      createdAt: faker.date.past(),
      deadline: faker.date.recent(),
      articleExternalReference: genericId(),
      articleName: faker.commerce.productName(),
      articleTotalQuantity: faker.datatype.number({ min: 1, max: 999 }),
      ...data,
    };
  },
  createOrderInput: (data?: Partial<OrderInput>): OrderInput => {
    return {
      externalReference: genericId(),
      deadline: faker.date.future(),
      type: _.sample(Object.values(OrderType)) ?? OrderType.DELIVERY,
      location: fakeLocationFactory.createLocation(),
      articles: [...Array(5)].map(fakeOrderFactory.createOrderArticle),
      ...data,
    };
  },
  createMatchInput: (data?: Partial<MatchOrder>): MatchOrder => {
    return {
      articles: [...Array(5)].map(fakeLoadFactory.createLoadArticle),
      matchedLocation: fakeLocationFactory.createLocation(),
      ...data,
    };
  },
  createOrder: (data?: Partial<Order>): Order => {
    return {
      id: orderId(),
      tenantId: tenantId(),
      createdAt: faker.date.past(),
      updatedAt: faker.date.recent(),
      ...fakeOrderFactory.createOrderInput(),
      loads: [],
      status: OrderStatus.UNMATCHED,
      ...data,
    };
  },
  createOrderArticle: (data?: Partial<OrderArticle>): OrderArticle => {
    return {
      article: fakeArticleFactory.createArticle(),
      totalQuantity: faker.datatype.number({ min: 1, max: 999 }),
      totalLoadingMillimeter: faker.datatype.number({ min: 1, max: 999 }),
      totalWeightInKg: faker.datatype.number({ min: 1, max: 999 }),
      ...data,
    };
  },
};
